export default "__VITE_ASSET__2a6923da__"